import React from "react";
import util from "../../util/tools";
import commonTools from "../../../common/util/util";
import { goRoute } from "../common/js";
import cityData from "../../util/city";
import Img from "react-image";
import P from "prop-types";
import { Link } from "react-router-dom";
import Toast from '../common/Toast'
import "./index.css";

export default class Home extends React.Component {
  static propTypes = {
    location: P.any,
    history: P.any,
    actions: P.any
  };

  constructor(props) {
    super(props);
    this.timer1;
    this.state = {
      curTitle: "幸运抽大奖",
      multiArray: [cityData, [], []],
      data: {
        name: "",
        tel: ""
      },
      noMoney: false,//是否有钱 默认false为有钱
      curClass: "",//转盘当前状态 默认为空:不动 draw-none:一直转 draw-n:第n个奖品(n为1-8)0点开始逆时针数
      showRuleBox: "",//是否显示弹窗 type1:规则弹窗 type2:多个奖品弹窗 type3:一等奖 type4:二等奖 type5:三等奖 type6:四等奖 type7:五等奖 type8:六等奖
      // 得奖轮播消息
      getjiangData: [],
      activeArr: [],
      cur: 0,//当前选中的中奖信息
      next: 1,//下一个选中的中奖信息
      drawData: [],//转盘数据
      text: "",
      // 奖品介绍
      jiangpinList: [
        {
          label: "一等奖",
          txt: "华为手机P30一台"
        },{
          label: "二等奖",
          txt: "名牌拉杆箱20寸一台",
        },{
          label: "三等奖",
          txt: "100元话费",
        },{
          label: "四等奖",
          txt: "全站免费阅读3天",
        },{
          label: "五等奖",
          txt: "5元无门槛现金",
        },{
          label: "六等奖",
          txt: "50金币"
        }
      ]
    };

    this.calcNum = this.calcNum.bind(this);
    this.beginFun = this.beginFun.bind(this);
    this.getDataJiang = this.getDataJiang.bind(this);
    this.randomFun = this.randomFun.bind(this);
    this.showDialog1 = this.showDialog1.bind(this);
    this.defJFun  = this.defJFun.bind(this);
    this.slideJFun = this.slideJFun.bind(this);
    this.charge = this.charge.bind(this);
    this.jhFun = this.jhFun.bind(this);
    this.changeFun = this.changeFun.bind(this);
    this.xxdzFun = this.xxdzFun.bind(this);
    this.subFun = this.subFun.bind(this);
    this.jpjsFun = this.jpjsFun.bind(this);
  }

  subFun(type){//1一等奖，所有信息必填 3三等奖，只填手机号姓名
    let text = "";
    if(!this.state.data.tel){
      text = "请填写手机号";
    }
    if(!this.state.data.name){
      text = "请填写姓名";
    }
    if(type == 1){
      if(!this.state.data.province){
        text = "请选择省份";
      }
      if(!this.state.data.city){
        text = "请选择城市";
      }
      if(!this.state.data.county){
        text = "请选择地区";
      }
      if(!this.state.data.address){
        text = "请输入详细地址";
      }
    }

    if(!!text){
      this.setState({
        text: text
      },()=>{
        clearTimeout(this.timer1);
        this.timer1 = setTimeout(()=>{
          this.setState({
            text:""
          })
        },2000)
      });
      return false;
    }

    util.ajax({
      url: "/zh/drawprize/addAddress",
      method: "POST",
      isUser: true,
      isWechatId: true,
      data: {
        ...this.state.data,
        draw_record_id: this.state.activeArr[0].draw_record_id
      },
      callback: res => {
        if (res.result.status.code == 0) {
          this.showDialog1();
        }
        this.setState({
          text: res.result.status.msg
        },()=>{
          clearTimeout(this.timer1);
          this.timer1 = setTimeout(()=>{
            this.setState({
              text:""
            })
          },2000)
        });
      }
    });
  }

  xxdzFun(e) {
    const curT = e.target;
    const name = curT.getAttribute("name");
    const userInfo = this.state.data;
    userInfo[name] = curT.value;
    this.setState({
      data: userInfo
    });
  }

  changeFun(e) {
    const curT = e.target,
        name = curT.getAttribute("name"),
        curIndex = curT.getAttribute("data-index");
    const userInfo = this.state.data;
    let multiArray = this.state.multiArray;
    userInfo[name] = curT.value;
    if (curIndex == 1) {
        // 省
        userInfo["city"] = "";
        userInfo["county"] = "";

        // multiArray[0] = cityData;
        multiArray[1] = multiArray[0].filter(function(item){
            return item.name == userInfo[name];
        })[0].city;
        multiArray[2] = [];
    } else if (curIndex == 2) {
        // 市
        userInfo["county"] = "";
        multiArray[2] = multiArray[1].filter(function(item){
            return item.name == userInfo[name];
        })[0].districtAndCounty;
    }
    this.setState({
        multiArray: multiArray,
        userInfo: userInfo
    });
  }
  
  jhFun(){
    util.ajax({
      url: "/zh/drawprize/activeMember",
      isUser: true,
      isWechatId: true,
      data: {
        draw_record_id: this.state.activeArr[0].draw_record_id
      },
      callback: res => {
        if (res.result.status.code == 0) {
          this.showDialog1();
        }
        this.setState({
          text: res.result.status.msg
        },()=>{
          clearTimeout(this.timer1);
          this.timer1 = setTimeout(()=>{
            this.setState({
              text:""
            })
          },2000)
        });
      }
    });
  }

  charge(item){
    let bookId = this.state.bookId;
    let url = `${document.location.href}/recharge`
    let params = {
        'total_fee':item*10*10,
        'back_url':url,
        'error_url':url,
        type: 1
    }
    if(!!bookId){
        params.book_id = bookId
    }
    util.ajax({
      url: "/zh/pay/wgpay",
      method:'post',
      isUser: true,
      isWechatId: true,
      data: params,
      callback: res => {
        if (res.result.status.code == 0) {
          document.location.href = res.result.data.url
        }else {
          this.setState({
            text: res.result.status.msg
          },()=>{
            clearTimeout(this.timer1);
            this.timer1 = setTimeout(()=>{
              this.setState({
                text:""
              })
            },2000)
          });
        }
      }
    });
  }

  showDialog1(type){
    let obj = {
      showRuleBox: !this.state.showRuleBox ? type : ""
    };
    if(!!this.state.showRuleBox){
      obj.activeArr = [];
    }
    this.setState(obj);
  }

  randomFun(minNum,maxNum){
    return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10);
  }

  beginFun(num){
    if(!!this.state.curClass && this.state.curClass == "draw-none"){
      return false;
    }
    this.setState({
      curClass: "draw-none"
    },()=>{
      this.getDataJiang(num);
    });
  }

  getDataJiang(num){
    // 判断余额
    util.ajax({
      url: "/zh/drawprize/lottery",
      isUser: true,
      isWechatId: true,
      data: {
        lottery_type: num == 1 ? 1 : 2,
      },
      callback: res => {
        if (res.result.status.code == 0) {
          let data = res.result.data;
          let index = 0;
          this.state.drawData.forEach(function(item,idx){
            if(item.prize_id == data[0].prize_id){
              index = idx;
            }
          });
          switch(index){
            case 0:
              index = 1;
              break;
            default:
              index = 9 - index;
          }
          
          this.setState({
            activeArr: data,
            curClass: `draw-${index}`
          },()=>{
            if(!this.state.noMoney){
              setTimeout(()=>{
                this.setState({
                  showRuleBox: data.length > 1 ? "type2" : `type${parseInt(data[0].prize_level)+2}`,
                });
              },800*2);
            }
          });
        }else{
          this.setState({
            curClass: "",
          });
          if(!this.state.showRuleBox){
            this.setState({
              noMoney: true
            });
          }
        }
      }
    });
  }

  calcNum(cur,max){
    let temp = cur + 1;
    if(temp >= max){
      temp = 0;
    }
    return temp;
  }

  componentDidMount() {
    document.title = this.state.curTitle;
    this.tjFun();

    // 获取奖品信息
    this.defJFun();

    // 轮播获奖列表
    this.slideJFun();

    // 奖品介绍
    this.jpjsFun();
  }

  jpjsFun(){
    util.ajax({
      url: "/zh/prize/turnTable",
      // isUser: true,
      // isWechatId: true,
      data: {
      },
      callback: res => {
        if (res.result.status.code == 0) {
          let json = res.result.data;
          this.setState({jiangpinList: json});
        }
      }
    });
  }

  defJFun(){
    util.ajax({
      url: "/zh/prize/lists",
      // isUser: true,
      // isWechatId: true,
      data: {
      },
      callback: res => {
        if (res.result.status.code == 0) {
          let json = res.result.data;
          this.setState({drawData: json});
        }
      }
    });
  }
  slideJFun(type){
    util.ajax({
      url: "/zh/drawprize/winningInfo",
      isUser: true,
      isWechatId: true,
      data: {
        lottery_type: type || "",
        appoint: "1",
      },
      callback: res => {
        if (res.result.status.code == 0) {
          let json = res.result.data;
          this.setState({getjiangData: json},()=>{
            // 中奖轮播信息
            if(this.state.getjiangData.length > 1){
              clearInterval(this.timer1);
              this.timer1 = setInterval(()=>{
                this.setState({
                  cur: this.calcNum(this.state.cur,this.state.getjiangData.length),
                  next: this.calcNum(this.state.next,this.state.getjiangData.length)
                })
              },3000);
            }
          });
        }
      }
    });
  }

  tjFun(){
    util.ajax({
      url: "/zh/drawprize/recordViewNum",
      isUser: true,
      isWechatId: true,
      data: {
        type: 1,
      }
    });
  }

  componentWillUnmount(){
    clearInterval(this.timer1);
  }
  
  getData(type) {
    util.ajax({
      url: "/zh/book/ranking",
      isUser: true,
      isWechatId: true,
      data: {
        num: 10,
        page: 1,
        re_cid: type
      },
      callback: res => {
        if (res.result.status.code == 0) {
          let json = res.result.data;
          let tempObj = {};
          switch (type) {
            case 136:
              tempObj.data1 = json;
              break;
            default:
              tempObj.data2 = json;
          }
          this.setState(tempObj);
        }
      }
    });
  }

  render() {
    return (
      <div className="rotaryDraw">
        <div className="ruleBox">
          {/* <Link to="search" className="rule">
            规则
          </Link> */}
          <div className="rule" onClick={()=>this.showDialog1("type1")}>规则</div>
          <Img
            className="img1"
            src={require("../../images/rotaryDraw_bg1.png")}
          />
          <div className="listBox">
            {
              this.state.getjiangData.map((item,index)=>(
                <div className={`item text-overflow ${index==this.state.cur?"active":""} ${index==this.state.next?"active1":""}`} key={`listItem${index}`}>{item}</div>
              ))
            }
          </div>
        </div>
        <div className="drawBox">
          <Img
            className="img1"
            src={require("../../images/rotaryDraw_bg2.png")}
          />
          <div className={`tempBox ${this.state.curClass}`}>
            {
              this.state.drawData.map((item,index)=>(
                <div key={`draw_${index}`} className="temp">
                  <Img src={item.prize_img} className="img" />
                  <div className="txt text-overflow">{item.prize_level_name}</div>
                </div>
              ))
            }
          </div>
          <div className="startBtn">开始</div>
        </div>
        <div className="btns">
          <Img
            className="img1"
            src={require("../../images/rotaryDraw_bg3.png")}
          />
          <div className="tempBox">
            <div className="btn" onClick={()=>this.beginFun(1)}>50金币1次</div>
            <div className="btn" onClick={()=>this.beginFun(10)}>450金币10次</div>
          </div>
        </div>
        <div className="detailBox">
          <div className="title">奖品介绍</div>
          <div className="list">
            <div className="item">
              <div className="txt">等级</div>
              <div className="txt">奖品</div>
            </div>
            {this.state.jiangpinList.map((item,index) => (
              <div className="item" key={`key_${index}`}>
                <div className="txt text-overflow">{item.prize_level_name}</div>
                <div className="txt text-overflow">{item.prize_name}</div>
              </div>
            ))}
          </div>
        </div>
        {
          !!this.state.noMoney && 
          <div className='read_cover' >
            <div className='read_cover_bot read_rg_wrapper'>
              <div className='read_cover_bot_zhichi'>
                <span className='read_cover_bot_zhichi_jiesuo'>充值</span>
              </div>
              <p className='read_rg_desc'><span className='pl'>金币不足，请充值</span></p>
              <div className='read_rg_content'>
                <a className='read_rg_item' onClick={()=>this.charge(29.9)}><img src={require('../../../common/images/1_1.png')}/></a>
                <a className='read_rg_item' onClick={()=>this.charge(49.9)}><img src={require('../../../common/images/2_1.png')}/></a >
                <a className='read_rg_item' onClick={()=>this.charge(99.9)}><img src={require('../../../common/images/3_1.png')}/></a>
                <a className='read_rg_item' onClick={()=>this.charge(199.9)}><img src={require('../../../common/images/4_1.png')}/></a>
              </div>
              <div className='read_cover_bot_tips'>*虚拟商品购买后不可退换</div>
            </div>
          </div>
        }
        {
          !!this.state.showRuleBox && 
          <div className="ruleDialogBox">
            <div className={`ruleConBox ${this.state.showRuleBox=="type1"?"":"active"} ${this.state.showRuleBox=="type9"?"active1-":""}`}>
              {/* 抽奖规则 */}
              {
                this.state.showRuleBox == "type1" && (
                  <div>
                    <div className="title">抽奖规则</div>
                    <div className="tip">1. 本活动需用户使用金币兑换抽奖次数。</div>
                    <div className="tip">2. 所获得的奖品可在“个人中心-我的奖品”中查看。所有优惠券不找零、不兑换，详细使用规则参照“个人中心-我的奖品”内对应奖项细则。</div>
                    <div className="btn mt4rem enterBtn" onClick={this.showDialog1}>确定</div>
                  </div>
                )
              }
              {/* 单个奖项 */}
              {
                this.state.activeArr.length == 1 && 
                <div>
                  <div className="tip1 text-overflow">{this.state.showRuleBox!="type9-"?"获得":""}{this.state.activeArr[0].prize_level_name}</div>
                  {
                    ["type31","type51","type9-"].indexOf(this.state.showRuleBox)<0 &&
                    <div className="tip1 text-overflow">{this.state.activeArr[0].prize_name}</div>
                  }
                  {/* 填写收货地址 */}
                  {
                    this.state.showRuleBox == "type3" && (
                      <div>
                        {
                          this.state.activeArr[0].is_fill != 0 &&
                          <div>
                            <div className="tip tc mt2rem">请填写收货信息</div>
                            <input type="text" className="txt_inp" name="name" value={this.state.data.name} onInput={this.xxdzFun} placeholder="请输入收货人" />
                            <input type="text" className="txt_inp" name="tel" value={this.state.data.tel} onInput={this.xxdzFun} placeholder="请输入手机号" />
                            <div className='item clearfix' data-title="省/市/区">
                              <select
                                  className="sel1"
                                  data-index="1"
                                  name="province"
                                  onChange={this.changeFun}
                                  value={this.state.data.province}
                              >
                                {!this.state.data.province && <option>选择省份</option>}
                                {
                                  this.state.multiArray[0].length > 0 &&
                                  this.state.multiArray[0].map((item, index) => (
                                      <option
                                          key={`a${index}`}
                                          value={`${item.name}`}
                                      >{item.name}</option>
                                  ))
                                }
                              </select>
                              <select
                                  className="sel1"
                                  data-index="2"
                                  name="city"
                                  onChange={this.changeFun}
                                  value={this.state.data.city}
                              >
                                {!this.state.data.city_info && <option>选择城市</option>}
                                {this.state.multiArray[1].length > 0 &&
                                this.state.multiArray[1].map((item, index) => (
                                    <option
                                        key={`b${index}`}
                                        value={`${item.name}`}
                                    >{item.name}</option>
                                ))}
                              </select>
                              <select
                                  className="sel1"
                                  data-index="3"
                                  name="county"
                                  onChange={this.changeFun}
                                  value={this.state.data.county}
                              >
                                {!this.state.data.county && (
                                <option>选择地区</option>
                                )}
                                {this.state.multiArray[2].length > 0 &&
                                this.state.multiArray[2].map((item, index) => (
                                    <option
                                        key={`c${index}`}
                                        value={`${item}`}
                                    >{item}</option>
                                ))}
                              </select>
                            </div>
                            <input
                                type="text"
                                onInput={this.xxdzFun}
                                className="txt2"
                                name="address"
                                placeholder="请输入详细地址街道/门牌号"
                                value={this.state.data.address}
                            ></input>
                          </div>
                        }
                        <div className="btn mt4rem enterBtn" onClick={()=>this.subFun(1)}>确定</div>
                      </div>
                    )
                  }
                  {/* 获得二等奖 拉杆箱====确定 */}
                  {
                    this.state.showRuleBox == "type4" && (
                      <div>
                        <Link to="wuliulist" className="btn mt4rem enterBtn" onClick={this.showDialog1}>确定</Link>
                      </div>
                    )
                  }
                  {/* 获得三等奖  输入手机号 */}
                  {
                    this.state.showRuleBox == "type5" && (
                      <div>
                        {
                          this.state.activeArr[0].is_fill != 0 &&
                          <div>
                            <div className="tip tc mt2rem">请填写个人信息</div>
                            <input type="text" className="txt_inp" name="tel" value={this.state.data.tel} onInput={this.xxdzFun} placeholder="请输入手机号" />
                            <input type="text" className="txt_inp" name="name" value={this.state.data.name} onInput={this.xxdzFun} placeholder="请输入姓名" />
                            <div className="tip2">请立即填写个人信息，否则视为放弃</div>
                          </div>
                        }
                        <div className="btn mt4rem enterBtn" onClick={()=>this.subFun(3)}>确定</div>
                      </div>
                    )
                  }
                  {/* 获得四等奖  免费阅读-立即激活 */}
                  {
                    this.state.showRuleBox == "type6" && (
                      <div>
                        <div className="btn mt4rem activeBtn" onClick={this.jhFun}>立即激活</div>
                      </div>
                    )
                  }
                  {/* 获得五等奖 5元无门槛现金====立即使用 */}
                  {
                    this.state.showRuleBox == "type7" && (
                      <div>
                        <div className="tip2">该现金仅用于用户充值使用</div>
                        <Link to="recharge?type=1" className="btn mt4rem active1Btn" onClick={this.showDialog1}>立即使用</Link>
                      </div>
                    )
                  }
                  {/* 获得六等奖 金币====好的 */}
                  {
                    this.state.showRuleBox == "type8" && (
                      <div>
                        <div className="tip2">请到“个人中心”查询金币</div>
                        <div className="btn mt4rem okBtn" onClick={this.showDialog1}>好的</div>
                      </div>
                    )
                  }
                  {/* 谢谢惠顾====好的 */}
                  {
                    this.state.showRuleBox == "type9" && (
                      <div>
                        {/* <div className="tip1">大奖越来越近了！</div> */}
                        <div className="btn mt4rem okBtn" onClick={this.showDialog1}>好的</div>
                      </div>
                    )
                  }
                </div>
              }
              {/* 多个奖项 */}
              {
                this.state.activeArr.length > 1 && 
                <div>
                  <div className="tip1">获得以下奖项</div>
                  {
                    this.state.activeArr.map((item,index)=>(
                      <div>
                        <div className={`tip text-overflow ${index==0?"mt4rem":""}`}><span className="fw">{item.prize_level_name}:</span> {item.prize_name}</div>
                      </div>
                    ))
                  }
                  <div className="tip2">请在 个人信息-我的奖品 中查看 详情并填写中奖信息</div>
                  <Link to="rotaryList" className="btn mt4rem active2Btn">前往我的奖品</Link>
                </div>
              }
            </div>
          </div>
        }
        <Toast text={this.state.text} key='3'/>
      </div>
    );
  }
}
